import { filter } from "lodash/fp"
import { entityIdDoesNotEqualId } from "./entityIdDoesNotEqualId"

export const filterEntityWithId = (entities: any[], id: string) => {
  return filter(entityIdDoesNotEqualId(id))(entities)
}
